
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexhQEfVT7IVD29KJuTQrkdDJzVVAALwhKcpYdtJA_45Yx10Meta } from "/var/www/html/src/pages/login/index.vue?macro=true";
import { default as indexvdKnw5G0ZD8k78s8N_45OE0r7bK8y7M7MFy7bjkRP8A7AMeta } from "/var/www/html/src/pages/panel/index.vue?macro=true";
import { default as indexX_vYza3e2R29dTtHuTunm5_hblhH9xCRkbY5m6E0604Meta } from "/var/www/html/src/pages/register/index.vue?macro=true";
import { default as indexIua93P62OFOhMmHCrJel8wyxmcQZPDZOOIzqUVbXLoUMeta } from "/var/www/html/src/pages/panel/tags/index.vue?macro=true";
import { default as indexaiqU_45rK9OXu_NA4JZV80MFVxVnQYML7w7V_45py48dwn4Meta } from "/var/www/html/src/pages/playground/index.vue?macro=true";
import { default as indexsPq0Z53_45s_45XSaQGrq8520cL8AbtIS4yPKb6LYW8_45DusMeta } from "/var/www/html/src/pages/panel/points/index.vue?macro=true";
import { default as indexaXPamct3xJrTRU0_45PNYnrNVla2453_45E8qtMQXEaD784Meta } from "/var/www/html/src/pages/panel/system/index.vue?macro=true";
import { default as index12CajMl_453VMWII_45DyQDSADv5AfjZo17qCGBqW9PCPnYMeta } from "/var/www/html/src/pages/login/confirm/index.vue?macro=true";
import { default as indexGnM8wviJRorvPfNCTxkI70MIFOUBJsoOhnVvgujy_IAMeta } from "/var/www/html/src/pages/panel/profile/index.vue?macro=true";
import { default as indexn0Ka3WYbe1JEyN8qineAO9LI7DIsMkwLsa7fywBAudMMeta } from "/var/www/html/src/pages/reset-password/index.vue?macro=true";
import { default as indexQxOeC8b78MoxTTxHDJZipztdFIKxG3fbEapt8O_457T_450Meta } from "/var/www/html/src/pages/forgot-password/index.vue?macro=true";
import { default as index1o1K9UIrk3dbH4sLEtrIDezjni0MElcg3d6H3nP26TEMeta } from "/var/www/html/src/pages/panel/campaigns/index.vue?macro=true";
import { default as index82B7HMw6scmnGZh2ei1A1o4OPLIywMhVsowc8okuTKAMeta } from "/var/www/html/src/pages/panel/dashboard/index.vue?macro=true";
import { default as indexGfc9zbUumt9ZU2Oil2cE9cpdOThKL6OGtdDB8LuBSoEMeta } from "/var/www/html/src/pages/panel/complaints/index.vue?macro=true";
import { default as indexTVkMZYm_tQw_HRaq0HLLMDzrcs2IDwki3ohZFyzhfjEMeta } from "/var/www/html/src/pages/panel/diets/list/index.vue?macro=true";
import { default as indexiQpdIaDzTQL8JBn_1tdGiwuhO1dqxUT9zl5kqveihQUMeta } from "/var/www/html/src/pages/panel/diets/menu/index.vue?macro=true";
import { default as indexY5cSuyHwwDfRTQLRIM8Lp5vEbVUTh6DXVy2RIa_455T2kMeta } from "/var/www/html/src/pages/register/confirm/index.vue?macro=true";
import { default as indexp3K2L0M7CLU1KImD5GtB0fWpvvez63lyRQfGPOdzNzIMeta } from "/var/www/html/src/pages/panel/addons/list/index.vue?macro=true";
import { default as indexGFByDOSHNb9Z0PYFiC1daV3B8l0GEmWaxOkqhJCERTEMeta } from "/var/www/html/src/pages/panel/b2b-clients/index.vue?macro=true";
import { default as indexzDiFJB9Tmq_F3cRufuax90rlAaLShwgJQ8pzg9Mi5sQMeta } from "/var/www/html/src/pages/panel/diets/meals/index.vue?macro=true";
import { default as indexO9SnLHeHj9eX5bwCj2j0zVRhIpLoJP9tSqCbbztpKjgMeta } from "/var/www/html/src/pages/panel/price-lists/index.vue?macro=true";
import { default as indexwLR8_45NAFzQZFJ985yn3tNv_45AA6qSpX_451a3FO1iTaOqMMeta } from "/var/www/html/src/pages/email-confirmation/index.vue?macro=true";
import { default as indexiibTgO7t99SEhkMRCRFZw_45unOs_ROkOA7Oxa10ldC9UMeta } from "/var/www/html/src/pages/panel/clients/list/index.vue?macro=true";
import { default as indexZD0jHTsA4QoDXkg73aD7_oNfGrl5NXvl4BJ8NGD9Q6wMeta } from "/var/www/html/src/pages/panel/gadgets/list/index.vue?macro=true";
import { default as index2MWFuHxqCoXRd6L_MGkXUdwijcEbl5y5gqezLHdLjhQMeta } from "/var/www/html/src/pages/panel/clients/orders/index.vue?macro=true";
import { default as indexWEw621v1E2Z8_45MXlsPfoU27zvsdU_7aRokNg4tayzYUMeta } from "/var/www/html/src/pages/panel/discount-codes/index.vue?macro=true";
import { default as index2pv_xignnIGnzd7Cbyv_45qboXJtPdMZ8Ze54DF3O_45m74Meta } from "/var/www/html/src/pages/panel/employees/list/index.vue?macro=true";
import { default as indexOwLxPNcASGJCsjSOsNsmWUnMtcjthf58fm0WQe_45ym9EMeta } from "/var/www/html/src/pages/panel/gadgets/orders/index.vue?macro=true";
import { default as indexaBWJXhPnZWakpTpjocHd_45yJJ4ALc9g1Twbzaw643W4wMeta } from "/var/www/html/src/pages/panel/clients/reports/index.vue?macro=true";
import { default as indexh_45k_I2QOgmw086igB7xmmoVaLEFVelGBZwJX_4JYLP0Meta } from "/var/www/html/src/pages/panel/deliveries/list/index.vue?macro=true";
import { default as indexkPDdUulE91gxEoPKkV3VQPZAgQoyGo_45iJtbbAADl49EMeta } from "/var/www/html/src/pages/panel/diets/allergens/index.vue?macro=true";
import { default as indexAkMzykZO3RJJ1iI1kdwNgfBqH1jkLDtEOLx8PSWQzVEMeta } from "/var/www/html/src/pages/panel/diets/materials/index.vue?macro=true";
import { default as indexos_99V_bJ5aMC0X5BuEKAs0cvgaZ3iFKFUctLyO5Vw4Meta } from "/var/www/html/src/pages/panel/diets/mealpreps/index.vue?macro=true";
import { default as indexLuryBayFCj4RJhIHYb939RKTuE64Q_45WE5BGMH6E2pHYMeta } from "/var/www/html/src/pages/panel/external-orders/index.vue?macro=true";
import { default as indexVq9rP5RpourUMvPoFsPxvD2c_45qEUVgkX3VDZ05bxsOEMeta } from "/var/www/html/src/pages/panel/internal-orders/index.vue?macro=true";
import { default as indexq5_7AFDRHTBC8Qv0r1g3D1bQ6UBQy_vFDOW4XudXmWIMeta } from "/var/www/html/src/pages/panel/clients/opinions/index.vue?macro=true";
import { default as index8_s9CbACsJbNp8LTHs4_4520NzYB3BG8AR_jAmMb6gp0IMeta } from "/var/www/html/src/pages/panel/clients/packages/index.vue?macro=true";
import { default as indexDAeDme5JhmlmX3_45JKIdKSsOBPe7CMA10dsJLG_ef_45sQMeta } from "/var/www/html/src/pages/panel/clients/rankings/index.vue?macro=true";
import { default as indexXEEq1S3twWsV1bAQs3kpuuxPTv0TyKHNhvxFQ53uDe8Meta } from "/var/www/html/src/pages/reset-password/confirm/index.vue?macro=true";
import { default as index25ZtU4CP5mFDv63uUoqqpbRmLey1S84dVD3I8XWc0W8Meta } from "/var/www/html/src/pages/panel/addons/categories/index.vue?macro=true";
import { default as indexsUYD8HIJOEF8U_45SHRT5xu61NFDwfFQVTkEOwZB5AJ8MMeta } from "/var/www/html/src/pages/panel/campaigns/reports/index.vue?macro=true";
import { default as indexSDQcoGZ_459U5_4584WxU29UVCgiM15eLOTK9fhmqRtXEEEMeta } from "/var/www/html/src/pages/panel/gadgets/warehouse/index.vue?macro=true";
import { default as indexHHwUEeBDM_454flkxRY_yIXiB61p8WKglT0v95OKHqQE4Meta } from "/var/www/html/src/pages/panel/campaigns/settings/index.vue?macro=true";
import { default as indexq2LMDNcjxO69JjePG9nBUHb_45LChofKjKcvoVVRlr7PUMeta } from "/var/www/html/src/pages/panel/clients/newsletter/index.vue?macro=true";
import { default as index6hXj2OxolT9gLqOcHEQNPh1DlteOMScrcYMXLccS_qMMeta } from "/var/www/html/src/pages/panel/deliveries/centers/index.vue?macro=true";
import { default as indexUfhCgQs9Drdl4EWJPz2WM4FEx3gonNjDJOa5IoUVoeoMeta } from "/var/www/html/src/pages/panel/deliveries/regions/index.vue?macro=true";
import { default as indexIeYmnuXlwEAtlTa7gJ1cIeAFoWiW32e1AgGsl1OqquwMeta } from "/var/www/html/src/pages/panel/diets/wyszukiwarka/index.vue?macro=true";
import { default as indexCEkr_450a3MMIIUef0c6Gd_oyqQhVh3ens1iC6O9gb6DwMeta } from "/var/www/html/src/pages/panel/employees/couriers/index.vue?macro=true";
import { default as indexpPD_45wrAQz8hmRS5QXGTwO0CwePY2woLeE5jwsPmIYcMMeta } from "/var/www/html/src/pages/panel/system/app-version/index.vue?macro=true";
import { default as indexKttXlIX7oINwdFclRjbmla13Sd78da_45l0dEv7_PaX4YMeta } from "/var/www/html/src/pages/panel/deliveries/schedule/index.vue?macro=true";
import { default as indexIb4EQ_SqHeOTXgrtcIB5DfJc0ZTlJGKU1YLzwBHMrMMMeta } from "/var/www/html/src/pages/panel/diets/semi-products/index.vue?macro=true";
import { default as index90_458KaOPONg6MZcukg85ZC83TYmP_DTsdB1WYbVtVA4Meta } from "/var/www/html/src/pages/panel/diets/size-matrices/index.vue?macro=true";
import { default as indexqTF1fhn4jtRfRxb_45kgUVF5XMkrykjyhU5LygpH_rsEwMeta } from "/var/www/html/src/pages/panel/clients/transactions/index.vue?macro=true";
import { default as indexcAahFKj6134tGDEScaWE78q5h9_RjQJCw7d_jMbspqcMeta } from "/var/www/html/src/pages/panel/deliveries/factories/index.vue?macro=true";
import { default as indexcWpm8U8Yp_gQdd5gC_SX1ciW3C8Otbb2kektiSarEtIMeta } from "/var/www/html/src/pages/panel/discounts/promotions/index.vue?macro=true";
import { default as indexCHHtDNBWDbnimB45IKntB564N3Rv85ocdc6nN7lLQAgMeta } from "/var/www/html/src/pages/panel/system/wallet-limits/index.vue?macro=true";
import { default as indexVnlk29zW7OW4lpuVKlX08upVV4fh7MgNhjt_45mmEpgcEMeta } from "/var/www/html/src/pages/panel/discounts/influencers/index.vue?macro=true";
import { default as index0jZbCWF3YExs3XVjRMdwiDguYVTmjoMMWCjBxXDkhpAMeta } from "/var/www/html/src/pages/panel/diets/production-errors/index.vue?macro=true";
import { default as indexa1FRV8qFbXor_guEYZV5KQqPCPYkTonOhBt6rgImPR8Meta } from "/var/www/html/src/pages/panel/gadgets/warehouse-status/index.vue?macro=true";
import { default as indexNtSR7AdjG9aPTqdlhPaTglxm4VtojNQdtSSfxZ1LMccMeta } from "/var/www/html/src/pages/panel/deliveries/box-packagings/index.vue?macro=true";
import { default as indexLTFs2j4MVcVyzTs15Mm_45bFyKG6L3uN_45bU_0BfLs7Fk0Meta } from "/var/www/html/src/pages/panel/deliveries/daily-deliveries/index.vue?macro=true";
import { default as indexuGGFl_453fRHYPVF1TFlN_J01scTLgccsubC5epx8TJo0Meta } from "/var/www/html/src/pages/panel/production-settings/sockets/index.vue?macro=true";
import { default as index4klAdrlsBETTWym_00MD7xeagp1sHMt_QbfkKFrOe_45AMeta } from "/var/www/html/src/pages/panel/deliveries/minimum-logistics/index.vue?macro=true";
import { default as indexV5OmR_DkkKJ9sQJglDp8XOquIOgz6guwun29gzCFX_454Meta } from "/var/www/html/src/pages/panel/diets/profitability-analysis/index.vue?macro=true";
import { default as indexP_oq_XcTRBkN_45sqseg8CLJ9ei9Ldqf1MOabe1thviM8Meta } from "/var/www/html/src/pages/panel/production-settings/machines/index.vue?macro=true";
import { default as indexS1uS5T1DVnP5OpmjI70YJ_9JXoehkM_KQ6k_4543vTXLIMeta } from "/var/www/html/src/pages/panel/deliveries/export-commodities/index.vue?macro=true";
import { default as indexYlgBjj61BbWfNfpnD3yTkhyp4US7EJex38YsLOUpE_45QMeta } from "/var/www/html/src/pages/panel/gadgets/category-and-partners/index.vue?macro=true";
import { default as index7nNTB2ODpDmIn0u7hZ4P0tg0I11PmS87N_GaqjQRjbMMeta } from "/var/www/html/src/pages/panel/production-settings/machine-types/index.vue?macro=true";
import { default as indexxF3lD_45ms6Qbl6algEyjeAw50B7ER9Knj3vHBwkHmXTQMeta } from "/var/www/html/src/pages/panel/production-settings/products-types/index.vue?macro=true";
export default [
  {
    name: "login",
    path: "/login",
    meta: { ...(indexhQEfVT7IVD29KJuTQrkdDJzVVAALwhKcpYdtJA_45Yx10Meta || {}), ...{"middleware":"no-authorization"} },
    component: () => import("/var/www/html/src/pages/login/index.vue")
  },
  {
    name: "panel",
    path: "/panel",
    meta: indexvdKnw5G0ZD8k78s8N_45OE0r7bK8y7M7MFy7bjkRP8A7AMeta || {},
    component: () => import("/var/www/html/src/pages/panel/index.vue")
  },
  {
    name: "register",
    path: "/register",
    props: {"type":"REGISTER"},
    meta: { ...(indexX_vYza3e2R29dTtHuTunm5_hblhH9xCRkbY5m6E0604Meta || {}), ...{"middleware":"register"} },
    component: () => import("/var/www/html/src/pages/register/index.vue")
  },
  {
    name: "panel-tags",
    path: "/panel/tags",
    meta: indexIua93P62OFOhMmHCrJel8wyxmcQZPDZOOIzqUVbXLoUMeta || {},
    component: () => import("/var/www/html/src/pages/panel/tags/index.vue")
  },
  {
    name: "playground",
    path: "/playground",
    component: () => import("/var/www/html/src/pages/playground/index.vue")
  },
  {
    name: "panel-points",
    path: "/panel/points",
    meta: indexsPq0Z53_45s_45XSaQGrq8520cL8AbtIS4yPKb6LYW8_45DusMeta || {},
    component: () => import("/var/www/html/src/pages/panel/points/index.vue")
  },
  {
    name: "panel-system",
    path: "/panel/system",
    meta: indexaXPamct3xJrTRU0_45PNYnrNVla2453_45E8qtMQXEaD784Meta || {},
    component: () => import("/var/www/html/src/pages/panel/system/index.vue")
  },
  {
    name: "login-confirm",
    path: "/login/confirm",
    meta: index12CajMl_453VMWII_45DyQDSADv5AfjZo17qCGBqW9PCPnYMeta || {},
    component: () => import("/var/www/html/src/pages/login/confirm/index.vue")
  },
  {
    name: "panel-profile",
    path: "/panel/profile",
    meta: indexGnM8wviJRorvPfNCTxkI70MIFOUBJsoOhnVvgujy_IAMeta || {},
    component: () => import("/var/www/html/src/pages/panel/profile/index.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: { ...(indexn0Ka3WYbe1JEyN8qineAO9LI7DIsMkwLsa7fywBAudMMeta || {}), ...{"middleware":"reset-password"} },
    component: () => import("/var/www/html/src/pages/reset-password/index.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: indexQxOeC8b78MoxTTxHDJZipztdFIKxG3fbEapt8O_457T_450Meta || {},
    component: () => import("/var/www/html/src/pages/forgot-password/index.vue")
  },
  {
    name: "panel-campaigns",
    path: "/panel/campaigns",
    meta: index1o1K9UIrk3dbH4sLEtrIDezjni0MElcg3d6H3nP26TEMeta || {},
    component: () => import("/var/www/html/src/pages/panel/campaigns/index.vue")
  },
  {
    name: "panel-dashboard",
    path: "/panel/dashboard",
    meta: index82B7HMw6scmnGZh2ei1A1o4OPLIywMhVsowc8okuTKAMeta || {},
    component: () => import("/var/www/html/src/pages/panel/dashboard/index.vue")
  },
  {
    name: "panel-complaints",
    path: "/panel/complaints",
    meta: indexGfc9zbUumt9ZU2Oil2cE9cpdOThKL6OGtdDB8LuBSoEMeta || {},
    component: () => import("/var/www/html/src/pages/panel/complaints/index.vue")
  },
  {
    name: "panel-diets-list",
    path: "/panel/diets/list",
    meta: indexTVkMZYm_tQw_HRaq0HLLMDzrcs2IDwki3ohZFyzhfjEMeta || {},
    component: () => import("/var/www/html/src/pages/panel/diets/list/index.vue")
  },
  {
    name: "panel-diets-menu",
    path: "/panel/diets/menu",
    meta: indexiQpdIaDzTQL8JBn_1tdGiwuhO1dqxUT9zl5kqveihQUMeta || {},
    component: () => import("/var/www/html/src/pages/panel/diets/menu/index.vue")
  },
  {
    name: "register-confirm",
    path: "/register/confirm",
    meta: { ...(indexY5cSuyHwwDfRTQLRIM8Lp5vEbVUTh6DXVy2RIa_455T2kMeta || {}), ...{"middleware":"register-confirm"} },
    component: () => import("/var/www/html/src/pages/register/confirm/index.vue")
  },
  {
    name: "panel-addons-list",
    path: "/panel/addons/list",
    meta: indexp3K2L0M7CLU1KImD5GtB0fWpvvez63lyRQfGPOdzNzIMeta || {},
    component: () => import("/var/www/html/src/pages/panel/addons/list/index.vue")
  },
  {
    name: "panel-b2b-clients",
    path: "/panel/b2b-clients",
    meta: indexGFByDOSHNb9Z0PYFiC1daV3B8l0GEmWaxOkqhJCERTEMeta || {},
    component: () => import("/var/www/html/src/pages/panel/b2b-clients/index.vue")
  },
  {
    name: "panel-diets-meals",
    path: "/panel/diets/meals",
    meta: indexzDiFJB9Tmq_F3cRufuax90rlAaLShwgJQ8pzg9Mi5sQMeta || {},
    component: () => import("/var/www/html/src/pages/panel/diets/meals/index.vue")
  },
  {
    name: "panel-price-lists",
    path: "/panel/price-lists",
    meta: indexO9SnLHeHj9eX5bwCj2j0zVRhIpLoJP9tSqCbbztpKjgMeta || {},
    component: () => import("/var/www/html/src/pages/panel/price-lists/index.vue")
  },
  {
    name: "email-confirmation",
    path: "/email-confirmation",
    meta: indexwLR8_45NAFzQZFJ985yn3tNv_45AA6qSpX_451a3FO1iTaOqMMeta || {},
    component: () => import("/var/www/html/src/pages/email-confirmation/index.vue")
  },
  {
    name: "panel-clients-list",
    path: "/panel/clients/list",
    meta: indexiibTgO7t99SEhkMRCRFZw_45unOs_ROkOA7Oxa10ldC9UMeta || {},
    component: () => import("/var/www/html/src/pages/panel/clients/list/index.vue")
  },
  {
    name: "panel-gadgets-list",
    path: "/panel/gadgets/list",
    meta: indexZD0jHTsA4QoDXkg73aD7_oNfGrl5NXvl4BJ8NGD9Q6wMeta || {},
    component: () => import("/var/www/html/src/pages/panel/gadgets/list/index.vue")
  },
  {
    name: "panel-clients-orders",
    path: "/panel/clients/orders",
    meta: index2MWFuHxqCoXRd6L_MGkXUdwijcEbl5y5gqezLHdLjhQMeta || {},
    component: () => import("/var/www/html/src/pages/panel/clients/orders/index.vue")
  },
  {
    name: "panel-discount-codes",
    path: "/panel/discount-codes",
    meta: indexWEw621v1E2Z8_45MXlsPfoU27zvsdU_7aRokNg4tayzYUMeta || {},
    component: () => import("/var/www/html/src/pages/panel/discount-codes/index.vue")
  },
  {
    name: "panel-employees-list",
    path: "/panel/employees/list",
    meta: index2pv_xignnIGnzd7Cbyv_45qboXJtPdMZ8Ze54DF3O_45m74Meta || {},
    component: () => import("/var/www/html/src/pages/panel/employees/list/index.vue")
  },
  {
    name: "panel-gadgets-orders",
    path: "/panel/gadgets/orders",
    meta: indexOwLxPNcASGJCsjSOsNsmWUnMtcjthf58fm0WQe_45ym9EMeta || {},
    component: () => import("/var/www/html/src/pages/panel/gadgets/orders/index.vue")
  },
  {
    name: "panel-clients-reports",
    path: "/panel/clients/reports",
    meta: indexaBWJXhPnZWakpTpjocHd_45yJJ4ALc9g1Twbzaw643W4wMeta || {},
    component: () => import("/var/www/html/src/pages/panel/clients/reports/index.vue")
  },
  {
    name: "panel-deliveries-list",
    path: "/panel/deliveries/list",
    meta: indexh_45k_I2QOgmw086igB7xmmoVaLEFVelGBZwJX_4JYLP0Meta || {},
    component: () => import("/var/www/html/src/pages/panel/deliveries/list/index.vue")
  },
  {
    name: "panel-diets-allergens",
    path: "/panel/diets/allergens",
    meta: indexkPDdUulE91gxEoPKkV3VQPZAgQoyGo_45iJtbbAADl49EMeta || {},
    component: () => import("/var/www/html/src/pages/panel/diets/allergens/index.vue")
  },
  {
    name: "panel-diets-materials",
    path: "/panel/diets/materials",
    meta: indexAkMzykZO3RJJ1iI1kdwNgfBqH1jkLDtEOLx8PSWQzVEMeta || {},
    component: () => import("/var/www/html/src/pages/panel/diets/materials/index.vue")
  },
  {
    name: "panel-diets-mealpreps",
    path: "/panel/diets/mealpreps",
    meta: indexos_99V_bJ5aMC0X5BuEKAs0cvgaZ3iFKFUctLyO5Vw4Meta || {},
    component: () => import("/var/www/html/src/pages/panel/diets/mealpreps/index.vue")
  },
  {
    name: "panel-external-orders",
    path: "/panel/external-orders",
    meta: indexLuryBayFCj4RJhIHYb939RKTuE64Q_45WE5BGMH6E2pHYMeta || {},
    component: () => import("/var/www/html/src/pages/panel/external-orders/index.vue")
  },
  {
    name: "panel-internal-orders",
    path: "/panel/internal-orders",
    meta: indexVq9rP5RpourUMvPoFsPxvD2c_45qEUVgkX3VDZ05bxsOEMeta || {},
    component: () => import("/var/www/html/src/pages/panel/internal-orders/index.vue")
  },
  {
    name: "panel-clients-opinions",
    path: "/panel/clients/opinions",
    meta: indexq5_7AFDRHTBC8Qv0r1g3D1bQ6UBQy_vFDOW4XudXmWIMeta || {},
    component: () => import("/var/www/html/src/pages/panel/clients/opinions/index.vue")
  },
  {
    name: "panel-clients-packages",
    path: "/panel/clients/packages",
    meta: index8_s9CbACsJbNp8LTHs4_4520NzYB3BG8AR_jAmMb6gp0IMeta || {},
    component: () => import("/var/www/html/src/pages/panel/clients/packages/index.vue")
  },
  {
    name: "panel-clients-rankings",
    path: "/panel/clients/rankings",
    meta: indexDAeDme5JhmlmX3_45JKIdKSsOBPe7CMA10dsJLG_ef_45sQMeta || {},
    component: () => import("/var/www/html/src/pages/panel/clients/rankings/index.vue")
  },
  {
    name: "reset-password-confirm",
    path: "/reset-password/confirm",
    component: () => import("/var/www/html/src/pages/reset-password/confirm/index.vue")
  },
  {
    name: "panel-addons-categories",
    path: "/panel/addons/categories",
    meta: index25ZtU4CP5mFDv63uUoqqpbRmLey1S84dVD3I8XWc0W8Meta || {},
    component: () => import("/var/www/html/src/pages/panel/addons/categories/index.vue")
  },
  {
    name: "panel-campaigns-reports",
    path: "/panel/campaigns/reports",
    meta: indexsUYD8HIJOEF8U_45SHRT5xu61NFDwfFQVTkEOwZB5AJ8MMeta || {},
    component: () => import("/var/www/html/src/pages/panel/campaigns/reports/index.vue")
  },
  {
    name: "panel-gadgets-warehouse",
    path: "/panel/gadgets/warehouse",
    meta: indexSDQcoGZ_459U5_4584WxU29UVCgiM15eLOTK9fhmqRtXEEEMeta || {},
    component: () => import("/var/www/html/src/pages/panel/gadgets/warehouse/index.vue")
  },
  {
    name: "panel-campaigns-settings",
    path: "/panel/campaigns/settings",
    meta: indexHHwUEeBDM_454flkxRY_yIXiB61p8WKglT0v95OKHqQE4Meta || {},
    component: () => import("/var/www/html/src/pages/panel/campaigns/settings/index.vue")
  },
  {
    name: "panel-clients-newsletter",
    path: "/panel/clients/newsletter",
    meta: indexq2LMDNcjxO69JjePG9nBUHb_45LChofKjKcvoVVRlr7PUMeta || {},
    component: () => import("/var/www/html/src/pages/panel/clients/newsletter/index.vue")
  },
  {
    name: "panel-deliveries-centers",
    path: "/panel/deliveries/centers",
    meta: index6hXj2OxolT9gLqOcHEQNPh1DlteOMScrcYMXLccS_qMMeta || {},
    component: () => import("/var/www/html/src/pages/panel/deliveries/centers/index.vue")
  },
  {
    name: "panel-deliveries-regions",
    path: "/panel/deliveries/regions",
    meta: indexUfhCgQs9Drdl4EWJPz2WM4FEx3gonNjDJOa5IoUVoeoMeta || {},
    component: () => import("/var/www/html/src/pages/panel/deliveries/regions/index.vue")
  },
  {
    name: "panel-diets-wyszukiwarka",
    path: "/panel/diets/wyszukiwarka",
    meta: indexIeYmnuXlwEAtlTa7gJ1cIeAFoWiW32e1AgGsl1OqquwMeta || {},
    component: () => import("/var/www/html/src/pages/panel/diets/wyszukiwarka/index.vue")
  },
  {
    name: "panel-employees-couriers",
    path: "/panel/employees/couriers",
    meta: indexCEkr_450a3MMIIUef0c6Gd_oyqQhVh3ens1iC6O9gb6DwMeta || {},
    component: () => import("/var/www/html/src/pages/panel/employees/couriers/index.vue")
  },
  {
    name: "panel-system-app-version",
    path: "/panel/system/app-version",
    meta: indexpPD_45wrAQz8hmRS5QXGTwO0CwePY2woLeE5jwsPmIYcMMeta || {},
    component: () => import("/var/www/html/src/pages/panel/system/app-version/index.vue")
  },
  {
    name: "panel-deliveries-schedule",
    path: "/panel/deliveries/schedule",
    meta: indexKttXlIX7oINwdFclRjbmla13Sd78da_45l0dEv7_PaX4YMeta || {},
    component: () => import("/var/www/html/src/pages/panel/deliveries/schedule/index.vue")
  },
  {
    name: "panel-diets-semi-products",
    path: "/panel/diets/semi-products",
    meta: indexIb4EQ_SqHeOTXgrtcIB5DfJc0ZTlJGKU1YLzwBHMrMMMeta || {},
    component: () => import("/var/www/html/src/pages/panel/diets/semi-products/index.vue")
  },
  {
    name: "panel-diets-size-matrices",
    path: "/panel/diets/size-matrices",
    meta: index90_458KaOPONg6MZcukg85ZC83TYmP_DTsdB1WYbVtVA4Meta || {},
    component: () => import("/var/www/html/src/pages/panel/diets/size-matrices/index.vue")
  },
  {
    name: "panel-clients-transactions",
    path: "/panel/clients/transactions",
    meta: indexqTF1fhn4jtRfRxb_45kgUVF5XMkrykjyhU5LygpH_rsEwMeta || {},
    component: () => import("/var/www/html/src/pages/panel/clients/transactions/index.vue")
  },
  {
    name: "panel-deliveries-factories",
    path: "/panel/deliveries/factories",
    meta: indexcAahFKj6134tGDEScaWE78q5h9_RjQJCw7d_jMbspqcMeta || {},
    component: () => import("/var/www/html/src/pages/panel/deliveries/factories/index.vue")
  },
  {
    name: "panel-discounts-promotions",
    path: "/panel/discounts/promotions",
    meta: indexcWpm8U8Yp_gQdd5gC_SX1ciW3C8Otbb2kektiSarEtIMeta || {},
    component: () => import("/var/www/html/src/pages/panel/discounts/promotions/index.vue")
  },
  {
    name: "panel-system-wallet-limits",
    path: "/panel/system/wallet-limits",
    meta: indexCHHtDNBWDbnimB45IKntB564N3Rv85ocdc6nN7lLQAgMeta || {},
    component: () => import("/var/www/html/src/pages/panel/system/wallet-limits/index.vue")
  },
  {
    name: "panel-discounts-influencers",
    path: "/panel/discounts/influencers",
    meta: indexVnlk29zW7OW4lpuVKlX08upVV4fh7MgNhjt_45mmEpgcEMeta || {},
    component: () => import("/var/www/html/src/pages/panel/discounts/influencers/index.vue")
  },
  {
    name: "panel-diets-production-errors",
    path: "/panel/diets/production-errors",
    meta: index0jZbCWF3YExs3XVjRMdwiDguYVTmjoMMWCjBxXDkhpAMeta || {},
    component: () => import("/var/www/html/src/pages/panel/diets/production-errors/index.vue")
  },
  {
    name: "panel-gadgets-warehouse-status",
    path: "/panel/gadgets/warehouse-status",
    meta: indexa1FRV8qFbXor_guEYZV5KQqPCPYkTonOhBt6rgImPR8Meta || {},
    component: () => import("/var/www/html/src/pages/panel/gadgets/warehouse-status/index.vue")
  },
  {
    name: "panel-deliveries-box-packagings",
    path: "/panel/deliveries/box-packagings",
    meta: indexNtSR7AdjG9aPTqdlhPaTglxm4VtojNQdtSSfxZ1LMccMeta || {},
    component: () => import("/var/www/html/src/pages/panel/deliveries/box-packagings/index.vue")
  },
  {
    name: "panel-deliveries-daily-deliveries",
    path: "/panel/deliveries/daily-deliveries",
    meta: indexLTFs2j4MVcVyzTs15Mm_45bFyKG6L3uN_45bU_0BfLs7Fk0Meta || {},
    component: () => import("/var/www/html/src/pages/panel/deliveries/daily-deliveries/index.vue")
  },
  {
    name: "panel-production-settings-sockets",
    path: "/panel/production-settings/sockets",
    meta: indexuGGFl_453fRHYPVF1TFlN_J01scTLgccsubC5epx8TJo0Meta || {},
    component: () => import("/var/www/html/src/pages/panel/production-settings/sockets/index.vue")
  },
  {
    name: "panel-deliveries-minimum-logistics",
    path: "/panel/deliveries/minimum-logistics",
    meta: index4klAdrlsBETTWym_00MD7xeagp1sHMt_QbfkKFrOe_45AMeta || {},
    component: () => import("/var/www/html/src/pages/panel/deliveries/minimum-logistics/index.vue")
  },
  {
    name: "panel-diets-profitability-analysis",
    path: "/panel/diets/profitability-analysis",
    meta: indexV5OmR_DkkKJ9sQJglDp8XOquIOgz6guwun29gzCFX_454Meta || {},
    component: () => import("/var/www/html/src/pages/panel/diets/profitability-analysis/index.vue")
  },
  {
    name: "panel-production-settings-machines",
    path: "/panel/production-settings/machines",
    meta: indexP_oq_XcTRBkN_45sqseg8CLJ9ei9Ldqf1MOabe1thviM8Meta || {},
    component: () => import("/var/www/html/src/pages/panel/production-settings/machines/index.vue")
  },
  {
    name: "panel-deliveries-export-commodities",
    path: "/panel/deliveries/export-commodities",
    meta: indexS1uS5T1DVnP5OpmjI70YJ_9JXoehkM_KQ6k_4543vTXLIMeta || {},
    component: () => import("/var/www/html/src/pages/panel/deliveries/export-commodities/index.vue")
  },
  {
    name: "panel-gadgets-category-and-partners",
    path: "/panel/gadgets/category-and-partners",
    meta: indexYlgBjj61BbWfNfpnD3yTkhyp4US7EJex38YsLOUpE_45QMeta || {},
    component: () => import("/var/www/html/src/pages/panel/gadgets/category-and-partners/index.vue")
  },
  {
    name: "panel-production-settings-machine-types",
    path: "/panel/production-settings/machine-types",
    meta: index7nNTB2ODpDmIn0u7hZ4P0tg0I11PmS87N_GaqjQRjbMMeta || {},
    component: () => import("/var/www/html/src/pages/panel/production-settings/machine-types/index.vue")
  },
  {
    name: "panel-production-settings-products-types",
    path: "/panel/production-settings/products-types",
    meta: indexxF3lD_45ms6Qbl6algEyjeAw50B7ER9Knj3vHBwkHmXTQMeta || {},
    component: () => import("/var/www/html/src/pages/panel/production-settings/products-types/index.vue")
  }
]